module.exports = __webpack_public_path__ + "static/apple-banner-v2-a3a6c71597e2e5c6f64fcb2918695733.png";